import type { ColumnDefinition } from "../../../ui/components/Table/types";
import type { FeatureFlag } from "../../lib/api/feature-flags";
import type { TranslateValues } from "../../lib/i18n";
import * as s from "./FeaturesListPage.css";

function truncate(value: string, max = 60): string {
  return value.length > max ? `${value.slice(0, max - 1)}…` : value;
}

export function createFeatureFlagsTableColumns(
  t: (key: string, values?: TranslateValues) => string,
): ColumnDefinition<FeatureFlag>[] {
  const TYPE_LABELS: Record<FeatureFlag["type"], string> = {
    boolean: t("pro.system.featureFlags.type.boolean"),
    string: t("pro.system.featureFlags.type.string"),
    number: t("pro.system.featureFlags.type.number"),
    enum: t("pro.system.featureFlags.type.enum"),
  };

  return [
    {
      id: "label",
      label: t("pro.system.featureFlags.col.label"),
      sortable: true,
      pinnedLeft: true,
      render: (row) => row.label,
    },
    {
      id: "group",
      label: t("pro.system.featureFlags.col.group"),
      sortable: true,
      render: (row) =>
        row.groupName ? <span>{row.groupName}</span> : <span className={s.muted}>—</span>,
    },
    {
      id: "key",
      label: t("pro.system.featureFlags.col.key"),
      sortable: true,
      render: (row) => <span className={s.mono}>{row.key}</span>,
    },
    {
      id: "type",
      label: t("pro.system.featureFlags.col.type"),
      render: (row) => <span className={s.pill}>{TYPE_LABELS[row.type]}</span>,
    },
    {
      id: "value",
      label: t("pro.system.featureFlags.col.globalValue"),
      render: (row) => <span className={`${s.mono} ${s.muted}`}>{truncate(row.value)}</span>,
    },
    {
      id: "overrideCount",
      label: t("pro.system.featureFlags.col.overrides"),
      render: (row) => {
        if (!row.overridable) {
          return <span className={s.pill}>{t("pro.system.featureFlags.scope.globalBadge")}</span>;
        }
        const count = row.overrideCount ?? 0;
        if (count === 0) return <span className={s.muted}>—</span>;
        return <span className={s.accentPill}>{t("pro.system.featureFlags.overrideCount", { count })}</span>;
      },
    },
  ];
}
